import React from "react";

const BreadScrumb = (props) => {
  return (
    <>
      <section
        id="subheader"
        className=" xyz relative jarallax text-light"
        style={{
          backgroundImage: `url(${props.Banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container relative z-2">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <h1>{props.title}</h1>
            </div>
          </div>
        </div>
        <div className="crumb-wrapper">
          <ul className="crumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li className="active">{props.title}</li>
          </ul>
        </div>
        <div className="sw-overlay"></div>
      </section>
    </>
  );
};

export default BreadScrumb;
